import { Injectable } from '@angular/core';

export interface IappEnv {
  production: boolean;
}


@Injectable({
  providedIn: 'root'
})
export class AppEnvironmentService {
  static environment: IappEnv;

  constructor() { }
}
